"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurCorePillars() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222745" id="the-precision-advantage" className="py-24 bg-background text-foreground relative overflow-hidden" ref={ref}>
      <div className="container mx-auto px-4 md:px-6">
        <div className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-default text-foreground mb-6 tracking-tighter">
            Most landowners are making timber decisions without a clear baseline
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            If you own land with timber, it can be difficult to know what’s actually growing on your property or whether it has meaningful value.
            <div><br /></div>
            <div data-ast-id="f:/src/pages/Home/sections/OurCorePillars.tsx|sig:56nb1o" data-ast-start="2027" data-ast-end="2044">
              <br />
            </div>
          </p>
        </div>
      </div>
    </section>;
}